import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

const MetricCard = ({ title, value, change, icon: Icon, format = 'number' }) => {
  const changeValue = change || 0;
  const isPositive = changeValue > 0;
  const isNeutral = changeValue === 0;
  const formattedValue = format === 'percentage' ? `${value || 0}%` :
                        format === 'time' ? `${value || 0}s` :
                        (value != null ? value.toLocaleString() : '0');

  return (
    <div className="rounded-[16px] border p-5 sm:p-6 transition-colors bg-white dark:bg-white/[0.02] border-gray-200 dark:border-white/[0.06]">
      <div className="flex items-center justify-between mb-4">
        <span className="text-sm font-medium text-gray-500 dark:text-gray-400">{title}</span>
        <div className="w-9 h-9 rounded-[10px] flex items-center justify-center bg-gray-50 dark:bg-white/[0.04]">
          <Icon className="w-4 h-4 text-gray-400 dark:text-gray-500" />
        </div>
      </div>

      <div className="text-3xl font-light tracking-tight text-gray-900 dark:text-white mb-2">
        {formattedValue}
      </div>

      <div className="flex items-center gap-1.5">
        {isNeutral ? (
          <Minus className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" />
        ) : isPositive ? (
          <TrendingUp className="w-3.5 h-3.5 text-green-500 flex-shrink-0" />
        ) : (
          <TrendingDown className="w-3.5 h-3.5 text-red-500 flex-shrink-0" />
        )}
        <span className={`text-xs font-medium ${
          isNeutral ? 'text-gray-400' : isPositive ? 'text-green-500' : 'text-red-500'
        }`}>
          {isPositive ? '+' : ''}{changeValue}%
        </span>
        <span className="text-xs text-gray-400 dark:text-gray-600">vs last month</span>
      </div>
    </div>
  );
};

export default MetricCard;
